// components/common/Spinner.jsx
// Loading spinner shown while data is fetching
// Used throughout the app wherever loading state exists

import React from 'react';

const Spinner = ({ size = 'md', fullPage = false }) => {
  const sizes = {
    sm: { width: 24, height: 24, border: 3 },
    md: { width: 40, height: 40, border: 4 },
    lg: { width: 60, height: 60, border: 5 },
  };

  const { width, height, border } = sizes[size] || sizes.md;

  const spinnerStyle = {
    width,
    height,
    borderWidth: border,
    borderStyle: 'solid',
    borderColor: 'var(--color-light-gray)',
    borderTopColor: 'var(--color-accent)',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  };

  if (fullPage) {
    return (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      }}>
        <div style={spinnerStyle} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
      <div style={spinnerStyle} />
    </div>
  );
};

export default Spinner;
